<div class="medical-history-settings">
  <div class="header">
    <div>
      <h1 class="title">{{ 'MEDICAL_HISTORY_SETTINGS_TITLE' | translate }}</h1>
      <p class="description">{{ 'MEDICAL_HISTORY_SETTINGS_DESCRIPTION' | translate }}</p>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
    </div>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="loadError && !loading">
    <span>{{ 'MEDICAL_HISTORY_LOAD_ERROR' | translate }}</span>
    <button type="button" class="alert-link-button" (click)="loadConfig()">
      {{ 'MEDICAL_HISTORY_RETRY' | translate }}
    </button>
  </div>

  <ng-container *ngIf="config && !loading">
    <div class="alert alert-danger" role="alert" *ngIf="saveError">
      {{ 'ERROR_SAVING_CHANGES' | translate }}
    </div>

    <div class="settings-grid">
      <section
        class="settings-card"
        *ngFor="let group of groups">
        <h2>{{ group.titleKey | translate }}</h2>

        <div class="option-list">
          <div class="option-row" *ngFor="let option of group.options">
            <mat-slide-toggle
              class="switch"
              [checked]="config[option.key]"
              [disabled]="saving"
              (change)="setValue(option.key, $event.checked)">
              {{ option.labelKey | translate }}
            </mat-slide-toggle>
          </div>
        </div>
      </section>
    </div>

    <div class="actions">
      <button
        type="button"
        class="secondary-btn"
        [disabled]="!hasChanges || saving"
        (click)="cancelChanges()">
        {{ 'CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="primary-btn"
        [disabled]="!hasChanges || saving"
        (click)="saveChanges()">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="saving"></span>
        {{ (saving ? 'SAVING' : 'SAVE') | translate }}
      </button>
    </div>
  </ng-container>
</div>

<div class="modal medical-history-confirm-modal" id="medicalHistoryVisibilitySuccessModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog medical-history-modal-dialog" role="document">
    <div class="modal-content medical-history-modal-content">
      <div class="modal-body medical-history-modal-body">
        <div class="success-check-circle" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none"
               stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="14 26 22 34 38 18"></polyline>
          </svg>
        </div>
        <h3>{{ 'SUCCESS' | translate }}</h3>
        <p>{{ 'MEDICAL_HISTORY_SAVE_SUCCESS' | translate }}</p>
      </div>
      <div class="modal-buttons">
        <button type="button" class="btn btn-confirm" (click)="closeModal()">
          {{ 'CLOSE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

